import {
  programCountriesByRegion,
  vulnerableCountryIsoCodes,
} from '@sola/contentful-model/lib/sac-values.ts';

type RegionCode = keyof typeof programCountriesByRegion;

/**
 * Returns the vulnerable countries for a given region by intersecting
 * the region's program countries with the global vulnerable list.
 */
const getVulnerableCountriesForRegion = (regionCode: RegionCode): string => {
  const regionCountries = programCountriesByRegion[regionCode];
  const vulnerable = regionCountries.filter((c) =>
    (vulnerableCountryIsoCodes as readonly string[]).includes(c),
  );
  return vulnerable.join(',');
};

const allVulnerableCountries = vulnerableCountryIsoCodes.join(',');

const isRegionCode = (value: string): value is RegionCode =>
  value in programCountriesByRegion;

export const filteredCountries = (
  causes?: string | null,
  location?: string | null,
): string | null => {
  if (!location) {
    return null;
  }

  if (!isRegionCode(location)) {
    return location;
  }

  if (causes === 'vulnerableExploitation') {
    return getVulnerableCountriesForRegion(location) || allVulnerableCountries;
  }

  return programCountriesByRegion[location].join(',');
};
